import React from "react";
import ContractualPartnerData from "@/src/components/Form/ContractLaw/Summary/ContractualPartnerData";
import Grid from "@mui/material/Grid";
import summaryStyle from "@/src/components/Form/Common/Style/summaryStyle";
import { Box } from "@mui/material";
import { translate } from "@/src/services/translations/translations";

type LandLordDataProps = {
  formData: Record<string, any>;
};

export const OpposingPartyData = ({ formData }: LandLordDataProps) => {
  const opposingPartyLabel =
    formData.contractPartyType === "tenant"
      ? translate("rentalContract.contractPartyType.options.landlord.label", formData)
      : translate("rentalContract.contractPartyType.options.tenant.label", formData);

  return (
    <>
      <ContractualPartnerData formData={formData} title={"Angaben zum " + opposingPartyLabel} />
      <Grid sx={summaryStyle.question} size={12}>
        <Box id={"name"} />
        Hausverwaltung vorhanden
      </Grid>
      <Grid size={12}>
        {formData.hasPropertyManager === "yes" ? "Ja" : "Nein"}
      </Grid>
      {formData.hasPropertyManager === "yes" && (
        <>
          <Grid sx={summaryStyle.question} size={12}>
            <Box id={"name"} />
            Name Hausverwaltung
          </Grid>
          <Grid size={12}>
            {formData.propertyManager.organization.legalName}
          </Grid>
          {formData.propertyManager.organization.address.streetAddress && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"streetAddress"} />
                Straße und Hausnummer Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.address.streetAddress}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.address.postalCode && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"postalCode"} />
                PLZ Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.address.postalCode}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.address.addressLocality && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"addressLocality"} />
                Ort Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.address.addressLocality}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.mainEmail.email && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"email"} />
                E-Mail Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.mainEmail.email}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.telephone && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"telephone"} />
                Telefonnummer Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.telephone}
              </Grid>
            </>
          )}
          {formData.propertyManager.organization.fax && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"telephone"} />
                Faxnummer Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManager.organization.fax}
              </Grid>
            </>
          )}
          {formData.propertyManagerReference && (
            <>
              <Grid sx={summaryStyle.question} size={12}>
                <Box id={"telephone"} />
                Aktenzeichen Hausverwaltung
              </Grid>
              <Grid size={12}>
                {formData.propertyManagerReference}
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
};
